import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { NstpWrapper } from "./_styles/NstpWrapper";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { MOVE_TO_NSTP } from "../../Config";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import appendRupee from "../../utils/appendRupee";
import { encryptedData } from "../../utils";

const Nstp = () => {
    const navigate = useNavigate();
    const [customerDetails, setCustomerDetails] = useContext(GetCustomerDetailsContext);

    useEffect(() => {
        if (validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
            var route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: customerDetails.stage,
            });
            navigate(`${route}`, {
                replace: true,
                state: {
                    customerDetails: customerDetails,
                },
            });
        }
    }, [customerDetails]);

    useEffect(() => {
        const MoveToNSTP = async () => {
            try {
                const payload = {
                };
                const formData = new FormData();
                formData.append("data", encryptedData(payload));
                const response = await sendRequest("/" + customerDetails.source + MOVE_TO_NSTP, formData);

                if (response.response.Success) {
                    setCustomerDetails({
                        ...customerDetails,
                        stage: response.response.STAGE,
                    });
                }
            } catch (error) {
                if (error === "Unauthorised") {
                    var route = getRouteFromLoanStageService({
                        source: customerDetails.source,
                        stage: "",
                    });
                    navigate(`${route}`, {
                        replace: true,
                    });
                } else {
                    console.error(`Unknown Error: ${error}`);
                    var route = getRouteFromLoanStageService({
                        source: customerDetails.source,
                        stage: "error",
                    });
                    navigate(`${route}`, {
                        replace: true,
                    });
                }
            }
        };
        if (customerDetails.stage === "NSTP_START") {
            MoveToNSTP()
        }
    }, []);

    return (
        <AfterLoginLayoutWrapper>
            <NstpWrapper className="nstp-wrapper">
                <div className="top-content">
                    <h4>You are eligible for loan upto</h4>
                    <h1>{appendRupee(customerDetails?.Data?.max_topup)}</h1>
                </div>
                <div className="card">
                    <p>Your application is under review. Please check after some time.</p>
                </div>
            </NstpWrapper>
        </AfterLoginLayoutWrapper>
    );
};

export default Nstp;
